import { FOOTER } from "../data/content";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="ilab-footer">
      <div className="container ilab-footer__top">
        <img
          className="ilab-footer__logo"
          src="/assets/logo/logo-white.png"
          alt="Intelligence Lab"
          width="300"
          height="170"
          loading="lazy"
        />

        {/* Three cells of the mark, reused as the rule. */}
        <span className="ilab-footer__rule" aria-hidden="true">
          <i />
          <i />
          <i />
        </span>
      </div>

      <div className="container ilab-footer__bottom">
        <p>{FOOTER.copyright}</p>
      </div>
    </footer>
  );
}
